// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__ShADL","header":"Header_header__UJkst","logo":"Header_logo__5krN2","loginBlock":"Header_loginBlock__cJtMI"};